import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tablePagination',
  standalone: false,
})
export class TablePaginationPipe implements PipeTransform {
  transform(items: string[], startIndex: number, length: number) {
    if (!items) {
      return items;
    }

    return items.slice(startIndex, startIndex + length);
  }
}
